import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const NotificationToggle = ({ icon, label, description, checked, onChange }) => {
  return (
    <div className="flex items-start justify-between gap-4 p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors">
      <div className="flex items-start gap-3 flex-1">
        <div className="mt-1">
          <Icon name={icon} size={20} className="text-muted-foreground" />
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-foreground mb-1">{label}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={onChange}
        className={cn(
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          checked ? "bg-primary" : "bg-input"
        )}
      >
        <span
          className={cn(
            "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
            checked ? "translate-x-6" : "translate-x-1"
          )}
        />
      </button>
    </div>
  );
};

export default NotificationToggle;